import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .filter('completedTasks', completedTasks);

function completedTasks() {
  return function completedTasksFilter(tasksListExt: any[], countAll: boolean) {

    if (!tasksListExt || !tasksListExt.length) {
      return '---'
    }

    const completedTasks = _.reduce(tasksListExt, (sum, t) => {
      if (t.status === 'Completed') {
        sum++;
      }
      return sum;
    }, 0);

    return `${completedTasks}${countAll ? `/` + tasksListExt.length : ''}`
  }
}

